export default "__VITE_ASSET__BpJIdzfC__"